<script setup>
defineProps({
  cols: { type: Number, default: 5 },
})
</script>

<template>
  <tr class="animate-pulse">
    <td v-for="i in cols" :key="i" class="px-4 py-3">
      <div class="h-4 bg-[color:var(--surfaceAlt)] rounded" :class="i === 1 ? 'w-16' : i === cols ? 'w-10' : 'w-full'"></div>
    </td>
  </tr>
</template>
